<template>
    <div class="share-wrapper">
        <span class="mr-m">Share this:</span>
        <a target="_blank" class="link mr-m" :href="fbUrl">Facebook</a>
        <a target="_blank" class="link" :href="twitterUrl">Twitter</a>
    </div>
</template>

<script>
    import { select as d3Select } from 'd3';
    export default {
        name: "Share",
        props: ['content'],
        data() {
            return {
                fbUrl: `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flens.kimalbrecht.com`,
                twitterUrl: `https://twitter.com/intent/tweet?source=https%3A%2F%2Flens.kimalbrecht.com&text=Curricle%20Lens:%20The%20history%20of%20harvards%20academia%20unveiled.%20Visualized,%20annotated,%20connected:%20what%20should%20the%20course%20catalog%20look%20like%20in%20the%2021st%20century.%20https%3A%2F%2Flens.kimalbrecht.com&via=metalabharvard%20@kmlbrcht%20@fdnklg`
            }
        },
        mounted() {
            setTimeout(() => {
				d3Select('.share-wrapper').classed('visible', true)
			}, 100)
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .share-wrapper {
        position: fixed;
        z-index: 100000;
        bottom: 40px;
        font-weight: 600;
        font-size: 13px;

        transform: rotate(-90deg);
        transform-origin: 100% 0%;
        right: 50px;
        bottom: 220px;

		@media screen and (max-width: 550px) {
            font-size: 13px;
            width: 200px;
            transform: rotate(0deg);
            left: calc(50% - 100px);
            // transform-origin: 100% 0%;
            // left: -210px;
            bottom: 15px;
		}



        @media screen and (max-height: 750px) and (max-width: 550px) {
            bottom: 25px;
        }

        @media screen and (min-height: 751px) and (max-width: 550px) {
            bottom: 30px;
        }
        
        @media screen and (max-height: 600px) and (max-width: 380px) {
			bottom: 15px;
		}

        opacity: 0;
        transition: all $time-m ease-in-out;
    }

    .visible {
        opacity: 1;
        transition: all $time-m ease-in-out;
    }

    .mr-m {
        margin-right: 15px;
    }

    .link {
        color: $color-primary;
        text-decoration: none;
        padding-bottom: 1px;
        border-bottom: 1px solid $color-primary;
    }  

    

</style>


